import styled from 'styled-components'

const Textarea = styled.textarea`
    border: 1px solid #2196f3; 
    padding: 1em; 
    width: 100%; 
`; 

export default Textarea